export default {
  datum: {
    type: 'datum',
    initializeBySelection: 0
  },
  x: {
    type: 'number',
    defaultValue: 0
  },
  y: {
    type: 'number',
    defaultValue: 0
  },
  z: {
    type: 'number',
    defaultValue: 0
  },
  copy: {
    type: 'boolean',
    defaultValue: false
  }
}